import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';

const defaultEl = {
  id: null,
  event_id: '',
  shift_id: '',
  minutes: ''
};

export default {
  name: 'ShiftEventEdit',
  components: {
    MinutesToText
  },
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      event_id: { required },
      shift_id: { required },
      minutes: { required }
    }
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['config']),
    eventOptions () {
      const path = 'ezuro/events/list?perPage=10000';
      const events = [];
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const key in response.data) {
            events.push({ value: response.data[key].id, text: response.data[key].name });
          }
          this.isLoading = false;
        }
      });
      return events;
    },
    baseTransParam () {
      return 'shift.events';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData, shift) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }

      this.editEl.shift_id = shift.id;

      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }

        const path = 'ezuro/shifts/events/save';

        this.ApiRequest.request(path + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
